export default __webpack_public_path__ + "static/media/studentIcon.f00796b3.svg";